import * as types from "../../constants";
import { Company } from "../../models/Company";
import * as actions from "../actions-declarations/company";
import { ActionsOf, init } from "../utils";
import { FETCH_COMPANIES } from "../../constants";

export type CompanyActions = typeof actions

export type CompanyActionType = {
  companies: Array<object> | Array<undefined>
  company: object;
  companyByProperty: object;
  error?: any
};

export type CompanyType = {
  company?: object | undefined;
  companyByProperty?: object | undefined;
  error?: any
};

export default function reducer(
  state = init<{
    companies?: Array<{ id: string, name: string }>,
    pagedCompanies?: Array<Company>
    company?: Company,
    companyByProperty?: Company,
    options?: any,
    error?: any,
    count?: number,
  }>({}),
  actions: ActionsOf<CompanyActions>
): typeof state {
  switch (actions.type) {
    case types.COMPANY_FETCH:
      return {
        ...state,
        company: actions.company,
      };
    case types.COMPANY_BY_PROPERTY_FETCH:
      return {
        ...state,
        companyByProperty: actions.company,
      };
    case types.CLEAR_COMPANY_BY_PROPERTY:
      return {
        ...state,
        companyByProperty: undefined,
      };
    case types.COMPANY_UPDATE:
      return {
        ...state,
        company: actions.company,
      }
    case types.COMPANY_BY_PROPERTY_UPDATE:
      return {
        ...state,
        companyByProperty: actions.company,
      }
    case types.COMPANYOPTIONS_FETCH:
      return {
        ...state,
        options: actions.options,
      }
    case types.COMPANY_ERROR:
      return {
        ...state,
        error: actions.error
      }
    case types.FETCH_COMPANIES:
      return {
        ...state,
        companies: actions.companies
      }
    case types.FETCH_PAGED_COMPANIES:
      return {
        ...state,
        pagedCompanies: actions.pagedCompanies
      }
    case types.CLEAR_PAGED_COMPANIES:
      return {
        ...state,
        pagedCompanies: []
      }
    case types.SET_COMPANY_COUNT:
      return {
        ...state,
        count: actions.count,
      };
    case types.CLEAR_COMPANY_ERROR:
      return {
        ...state,
        error: undefined
      }
    case types.CLEAR_COMPANY:
      return {
        ...state,
        company: undefined
      }
    default:
      return state;
  }
}
